import { ChangeDetectionStrategy, Component, computed, inject, linkedSignal, signal, viewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDialogComponent } from 'src/app/controls/components/advanced/modal-dialog/modal-dialog.component';
import { ButtonComponent } from 'src/app/controls/components/basic/button/button.component';
import { LayoutColumnComponent } from 'src/app/controls/components/basic/layout-column/layout-column.component';
import { LayoutRowComponent } from 'src/app/controls/components/basic/layout-row/layout-row.component';
import { PasswordComponent, PasswordComponentValue, PasswordMode } from 'src/app/controls/components/basic/password/password.component';
import { TextboxComponent } from 'src/app/controls/components/basic/textbox/textbox.component';
import { ButtonPrimaryDirective } from 'src/app/controls/directives/button-primary.directive';
import { ButtonSecondaryDirective } from 'src/app/controls/directives/button-secondary.directive';
import { OnboardingCredentials } from 'src/app/partnerportal/components/onboarding-credentials/models/credentials';

@Component({
  selector: 'app-partner-onboarding-provide-credentials-dialog',
  standalone: true,
  imports: [ModalDialogComponent, FormsModule, ButtonComponent, ButtonPrimaryDirective, ButtonSecondaryDirective, ModalDialogComponent, LayoutColumnComponent, LayoutRowComponent, TextboxComponent, PasswordComponent],
  templateUrl: './partner-onboarding-provide-credentials-dialog.component.html',
  styleUrl: './partner-onboarding-provide-credentials-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PartnerOnboardingProvideCredentialsDialogComponent {
  form = viewChild<NgForm>('form');
  private dialog = inject(NgbActiveModal);
  public credentials = signal<OnboardingCredentials>(null);
  public dialogResult = signal<PartnerOnboardingProvideCredentialsDialogResult>(null);

  PasswordMode = PasswordMode;

  username = linkedSignal(() => {
    const usernameValue = this.credentials()?.Username ?? '';
    return usernameValue;
  });
  password = linkedSignal<PasswordComponentValue>(() => {
    const passwordValue = this.credentials()?.Password ?? '';
    return {
      value: null,
      id: passwordValue
    };
  });

  result = computed(() => {
    const credentials: OnboardingCredentials | null = this.username() || this.password()?.value ? {
        Username: this.username(),
        Password: this.password()?.value ?? this.password()?.id
    } : null;
    const result: PartnerOnboardingProvideCredentialsResult = {
      credentials,
      dialogResult: this.dialogResult()
    };
    return result;
  });

  provide() {
    this.dialogResult.set(PartnerOnboardingProvideCredentialsDialogResult.Provide);
    this.dialog.close(this.result());
  }

  cancel() {
    this.dialogResult.set(PartnerOnboardingProvideCredentialsDialogResult.Cancel);
    this.dialog.close(this.result());
  }
}

export interface PartnerOnboardingProvideCredentialsResult {
  credentials: OnboardingCredentials;
  dialogResult: PartnerOnboardingProvideCredentialsDialogResult;
}

export enum PartnerOnboardingProvideCredentialsDialogResult {
  Provide,
  Cancel
}
